import React from 'react';
import Toast from 'src/components/Toast/Toast';

interface LossToastProps {
  toastVisible: boolean;
  lossDeleteErrorToast: boolean;
  lossDeleteSuccessToast: boolean;
}

const LossToast: React.FC<LossToastProps> = ({
  toastVisible,
  lossDeleteErrorToast,
  lossDeleteSuccessToast,
}) => {
  return (
    <>
      {toastVisible && (
        <Toast text="Details for this loss have been added successfully!" type="success" />
      )}
      {lossDeleteErrorToast && (
        <Toast
          text="An error occurred while deleting the selected loss. Please try again later."
          type="error"
        />
      )}
      {lossDeleteSuccessToast && (
        <Toast text="The selected loss has been deleted." type="success" />
      )}
    </>
  );
};

export default LossToast;
